import { Modal, Button, DropDown } from 'Common/Supplyvue-ui'
import { Box } from '@mui/material'
import { DownloadDataView } from 'Features/DownloadDataModal/DownloadData.view'
import { DataDownloadModalProps } from 'Features/DownloadDataModal/DownloadDataModal.types'
import { Loader } from 'Common/Loader/Loader'
import { SET_FILE_FORMAT, FILE_FORMATS } from './DownloadData.constants'

export const DownloadDataModal = ({
  keyMeasures,
  isKeyMeasuresLoading,
  isModalOpen,
  handleModalSave,
  handleModalCancel,
  heading,
  dataDownloadSettingsState,
  updateState,
  fileNameLabel,
  fileVersionLabel,
  keyFiguresLabel,
  fileNames,
  keyFigureLabels,
}: DataDownloadModalProps) => {
  const body = (
    <Box
      sx={{
        minWidth: '600px',
        maxWidth: '900px',
      }}
    >
      {isKeyMeasuresLoading ? (
        <Loader />
      ) : (
        <DownloadDataView
          keyMeasures={keyMeasures}
          fileNameLabel={fileNameLabel}
          fileVersionLabel={fileVersionLabel}
          keyFiguresLabel={keyFiguresLabel}
          fileName={dataDownloadSettingsState.fileName}
          fileFormat={dataDownloadSettingsState.fileFormat}
          fileVersion={dataDownloadSettingsState.fileVersion}
          keyFigures={dataDownloadSettingsState.keyFigures}
          updateState={updateState}
          fileNames={fileNames}
          keyFigureLabels={keyFigureLabels}
        />
      )}
    </Box>
  )

  const footer = (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'space-between',
      }}
    >
      <Button
        onClick={handleModalCancel}
        variant="outlined"
        sx={{
          display: 'flex',
          height: '40px',
          marginRight: '5px',
        }}
      >
        Cancel
      </Button>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Button
          sx={{
            display: 'flex',
            height: '40px',
          }}
          onClick={handleModalSave}
          variant="contained"
        >
          Download
        </Button>
        <DropDown
          id={fileNameLabel}
          sx={{
            display: 'flex',
            height: '40px',
          }}
          value={dataDownloadSettingsState.fileFormat ?? 'csv'}
          menuItems={FILE_FORMATS}
          label={fileNameLabel}
          onChange={(e) =>
            updateState({
              type: SET_FILE_FORMAT,
              payload: e.target.value as string,
            })
          }
        />
      </Box>
    </Box>
  )

  return (
    <Modal
      open={isModalOpen}
      header={heading}
      handleClose={handleModalCancel}
      body={body}
      footer={footer}
    />
  )
}
